import type { Kennzahl, GetValuesFn } from './types'

/**
 * Baut ein Bar+Line-Dataset für den BarChartStacked-Renderer:
 * Sub-1 (`{kennzahlId}1.`) als Bar auf der linken Achse,
 * Sub-2 (`{kennzahlId}2.`) als Line auf der rechten Achse.
 *
 * Verwendung: 1.2. (Einschreibungen als Bar, Zulassungen als Line)
 */
export function buildBarChartBarWithLine(kennzahl: Kennzahl, getValues: GetValuesFn, baseYears: string[]): any {
    const valuesOne = getValues(`${kennzahl.kennzahlId}1.`)
    const valuesTwo = getValues(`${kennzahl.kennzahlId}2.`)

    if (!valuesOne.length && !valuesTwo.length) return false

    const dataOne: { x: string; y: number }[] = []
    const dataTwo: { x: string; y: number }[] = []
    let maxValue = 0

    valuesOne.forEach((v1) => {
        const match = valuesTwo.find((v2) => v2.semester === v1.semester)
        if (match) {
            dataOne.push({ x: match.semester, y: Number(v1.wert) })
            dataTwo.push({ x: v1.semester, y: Number(match.wert) })
            maxValue = Math.max(Number(match.wert), Number(v1.wert), maxValue)
        }
    })

    maxValue = maxValue ? maxValue * 1.15 : 10

    return {
        labels: baseYears,
        datasets: [
            {
                type: 'line',
                label: kennzahl.datasetLabels?.[1] ?? '',
                data: dataTwo,
                borderColor: '#E5007D',
                backgroundColor: '#E5007D',
                tension: 0,
                borderWidth: 1,
                pointRadius: 2,
                fill: false,
                yAxisID: 'y1',
                maxValue
            },
            {
                type: 'bar',
                label: kennzahl.datasetLabels?.[2] ?? '',
                data: dataOne,
                backgroundColor: '#004699',
                yAxisID: 'y',
                maxValue
            }
        ]
    }
}
